<template>
  <div :id="'ezoic-pub-ad-placeholder-' + id">
    <Adsense
      data-ad-client="ca-pub-0703638893464633"
      data-ad-slot="9501178283"
      data-ad-format="fluid"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
  },
  mounted() {
    window.ezstandalone = window.ezstandalone || {};
    const ezstandalone = window.ezstandalone;
    ezstandalone.cmd = ezstandalone.cmd || [];
    ezstandalone.cmd.push(() => {
      ezstandalone.displayMore(this.id);
    });
  },
};
</script>
